export default "__VITE_ASSET__BJX3V6tb__"